// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c08ceccd","598":"ea0a094b","703":"7b0d94ef","787":"6ef5e871"}[chunkId] + ".chunk.js";
};